import {sortArtists} from '../app/sortArtists.js';
import {sliders} from '../app/sliders.js';
import {expositionsSlider} from '../app/expositionsSlider.js';
import {loadExpositions} from '../app/loadExpositions.js';
import {loadNews} from '../app/loadNews.js';
import {activateSelect2} from '../app/activateSelect2.js';
import {lightbox} from '../app/lightbox.js';


export default {
  init() {
    // JavaScript to be fired on all pages
    sortArtists();
    sliders();
    expositionsSlider();
    loadExpositions();
    loadNews();
    activateSelect2();
    lightbox();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
